export default __webpack_public_path__ + "static/media/Mark-2-HUD-00.d40895ac.jpg";